<script>
import { h } from 'vue';
import WidgetHost from './WidgetHost.vue';

const TAGS = new Set(['div', 'section', 'header', 'footer', 'main', 'aside', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span',
  'strong', 'em', 'small', 'ul', 'ol', 'li', 'hr', 'br', 'widget']);

function parse(template) {
  const doc = new DOMParser().parseFromString(`<body>${template || ''}</body>`, 'text/html');
  return Array.from(doc.body.childNodes);
}

export default {
  name: 'PageTemplate',
  props: {
    template: { type: String, required: true },
    placements: { type: Array, default: () => [] },
    widgets: { type: Object, default: () => ({}) },
    hostProps: { type: Object, default: () => ({}) },
  },
  emits: ['drill-entity', 'select-patient'],
  data() {
    return { empty: {} };
  },
  computed: {
    nodes() {
      return parse(this.template);
    },
    byId() {
      return Object.fromEntries(this.placements.map((p) => [p.id, p]));
    },
  },
  methods: {
    setEmpty(id, value) {
      if (!!this.empty[id] !== !!value) this.empty = { ...this.empty, [id]: !!value };
    },
    attrs(node) {
      const out = {};
      if (node.getAttribute('class')) out.class = node.getAttribute('class');
      if (node.getAttribute('style')) out.style = node.getAttribute('style');
      return out;
    },
    build(node) {
      if (node.nodeType === Node.TEXT_NODE) return node.textContent;
      if (node.nodeType !== Node.ELEMENT_NODE) return null;
      const tag = node.tagName.toLowerCase();
      if (!TAGS.has(tag)) return null;
      if (tag === 'widget') {
        const p = this.byId[node.getAttribute('id')];
        if (!p) return null;
        const attrs = this.attrs(node);
        return h('div', { ...attrs, key: p.id, 'data-placement': p.id, class: [attrs.class, 'pt-place', { 'pt-hidden': this.empty[p.id] }] }, [
          h(WidgetHost, {
            ...this.hostProps,
            placement: p,
            widget: this.widgets[p.widget],
            preloaded: this.hostProps.preloaded ? this.hostProps.preloaded[p.id] || {} : null,
            onEmpty: (value) => this.setEmpty(p.id, value),
            onDrillEntity: (e) => this.$emit('drill-entity', e),
            onSelectPatient: (e) => this.$emit('select-patient', e),
          }),
        ]);
      }
      return h(tag, this.attrs(node), Array.from(node.childNodes).map((c) => this.build(c)).filter((c) => c !== null));
    },
  },
  render() {
    return h('div', { class: 'pt' }, this.nodes.map((n) => this.build(n)).filter((n) => n !== null));
  },
};
</script>

<style scoped>
.pt-place { display: flex; flex-direction: column; min-width: 0; }
.pt-hidden { display: none !important; }
</style>
